import { createSlice } from "@reduxjs/toolkit";
import { getNotifications } from "api";

const initialState = {
  items: [],
  loading: false,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setNotifications: (state, action) => {
      state.items = action.payload;
    },
    notificationReceived: (state, action) => {
      const item = action.payload;
      if (!item || item.id == null) return;
      if (state.items.some((existing) => existing.id === item.id)) return;
      state.items.unshift({ ...item, seen: item.seen ?? false });
    },
  },
});

export const { setLoading, setNotifications, notificationReceived } =
  notificationsSlice.actions;

export const fetchNotifications =
  (showLoading = false) =>
  async (dispatch) => {
    if (showLoading) dispatch(setLoading(true));
    try {
      const response = await getNotifications();
      dispatch(setNotifications(response?.data?.data ?? []));
    } catch (error) {
      console.error(error);
    } finally {
      if (showLoading) dispatch(setLoading(false));
    }
  };

export const selectNotifications = (state) => state.notifications.items;
export const selectNotificationsLoading = (state) => state.notifications.loading;
export const selectUnseenCount = (state) =>
  state.notifications.items.filter((item) => item.seen === false).length;

export const notificationsReducer = notificationsSlice.reducer;
